import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.auth.isAuthenticated()) return true;

    console.warn('[AuthGuard] ⚠️ Invalid or expired session, redirecting to login.');
    this.router.navigate(['/auth/login']);
    return false;
  }
}
